import { getCurrencyExponent } from '../../../../lib/currencyFormatters';

export const mapToHeadlessItem = ({ item, quantity, exchangeOptions }) => {
  const uppercaseFirstChar = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const findProperty = (key) =>
    (item.item_properties || []).find((prop) => prop.key === key)?.value || '';
  const size = item.size || findProperty(uppercaseFirstChar('size'));
  const color = item.color || findProperty(uppercaseFirstChar('color'));

  return {
    type: item.item_eligibilities?.exchange?.is_eligible ? 'exchange' : 'return',
    name: item.item_name,
    itemId: item.item_id.toString(),
    remainingQuantity: 0,
    quantity,
    orderedQuantity: quantity,
    imageUrl: item.product_image_url,
    additionalProperties: [],
    availableReasons: [],
    availableReturnActions: [],
    price: {
      value: Math.round(item.item_price * getCurrencyExponent('USD')),
      currency: 'USD',
    },
    eligibilities: {
      exchange: {
        isEligible: item.item_eligibilities?.exchange?.is_eligible,
      },
      repair: {
        isEligible: item.item_eligibilities?.repair?.is_eligible,
      },
      return: {
        isEligible: item.item_eligibilities?.return?.is_eligible,
      },
    },
    size,
    color,
    variantInfo: exchangeOptions.reduce((acc, option) => {
      if (option.id === 'product') return acc;
      const useUppercase = Boolean(findProperty(uppercaseFirstChar(option.id)));
      const optionValue = useUppercase
        ? findProperty(uppercaseFirstChar(option.id))
        : item[option.id] || findProperty(option.id);
      return {
        ...acc,
        [option.id]: {
          optionId: option.id,
          optionName: useUppercase ? uppercaseFirstChar(option.id) : option.id,
          optionPosition: option.position,
          value: optionValue,
          name: optionValue,
          position: option.position,
        },
      };
    }, {}),
  };
};
